import {
  HydratedStory,
  HydratedStoryPoint,
  ReducedTrail,
  StoryPoint,
} from 'magical-trails';
import uniqueId from './uniqueId';
import setStoryPointsStatus from './set-story-points-status';

function sortByOrder(array: StoryPoint[]): StoryPoint[] {
  // Copy before sorting: hydrateStory runs inside RTK reducers on the trail
  // held in Redux, which is deep-frozen — an in-place .sort() throws
  // "Cannot assign to read only property" and aborts the dispatch (breaking
  // "Switch story" / multi-story scans).
  return [...array].sort((a, b) => a.order - b.order);
}

const hydrateStory = (
  trail: ReducedTrail,
  trailCode: string
): HydratedStory | undefined => {
  const targetStory = trail.stories.find((story) => story.code === trailCode);
  if (targetStory === undefined) {
    console.error('Specifies story does not exist in supplied trail');
    return undefined;
  }

  const sortedStoryPoints = sortByOrder(targetStory.storyPoints);
  const { updatedStoryPoints } = setStoryPointsStatus(
    sortedStoryPoints.map((storyPoint, index) => {
      const hydratedStoryPoint = {
        ...storyPoint,
        currentPage: 0,
        code: storyPoint.code || `${storyPoint.type}_${index}`,
      };
      if (storyPoint.type === 'location') {
        const locationPoint = trail.points.find(
          (point) => point.code === storyPoint.code
        );
        // Fall back to undefined (an open gate), NOT [0,0] "Null Island" — a
        // mis-linked location point with [0,0] leaves the player ~5,000,000 m
        // away from the geofence forever with no way to complete the point.
        (hydratedStoryPoint as any).latlng = locationPoint
          ? [locationPoint.lat, locationPoint.lng]
          : undefined;
        (hydratedStoryPoint as any).locationPoint = locationPoint;
      }
      return hydratedStoryPoint as HydratedStoryPoint;
    }),
    targetStory.config
  );
  return {
    code: trailCode,
    title: targetStory.title,
    storyPoints: updatedStoryPoints,
    trailSessionToken: uniqueId(),
    version: trail.version,
    startedAt: new Date().toISOString(),
    config: targetStory.config,
  };
};

export default hydrateStory;
